"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _oxygenConfig = require("@8x8/oxygen-config");
var _styled = require("../styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SwitchBaseInput = function SwitchBaseInput(_ref) {
  var testId = _ref.testId,
    name = _ref.name,
    id = _ref.id,
    value = _ref.value,
    icon = _ref.icon,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    onKeyPress = _ref.onKeyPress,
    role = _ref.role;
  return /*#__PURE__*/_react["default"].createElement(_styled.SwitchBaseInputWrapper, null, /*#__PURE__*/_react["default"].createElement(_styled.SwitchBaseInputField, _extends({}, (0, _oxygenConfig.getTestAttributes)(testId), {
    id: id,
    value: value,
    type: "checkbox",
    name: name,
    checked: isChecked,
    "aria-disabled": isDisabled,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    onKeyPress: onKeyPress,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    role: role
  })), icon);
};
SwitchBaseInput.propTypes = {
  /**
   * Switch test id
   */
  testId: _propTypes["default"].string.isRequired,
  /**
   * Input name
   */
  name: _propTypes["default"].string,
  /**
   * Value for `id` input attribute and `htmlFor` label attribute
   */
  id: _propTypes["default"].string.isRequired,
  /**
   * Input value
   */
  value: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].bool, _propTypes["default"].shape({
    id: _propTypes["default"].string.isRequired
  })]).isRequired,
  /**
   * Icon component for the switch base
   */
  icon: _propTypes["default"].node.isRequired,
  /**
   * Specifies if the switch is checked
   */
  isChecked: _propTypes["default"].bool.isRequired,
  /**
   * Specifies if the switch is disabled
   */
  isDisabled: _propTypes["default"].bool.isRequired,
  /**
   * Synthetic event
   */
  onBlur: _propTypes["default"].func.isRequired,
  /**
   * Callback for the switch input
   */
  onChange: _propTypes["default"].func.isRequired,
  /**
   * Synthetic event
   */
  onFocus: _propTypes["default"].func.isRequired,
  /**
   * Synthetic event
   */
  onMouseEnter: _propTypes["default"].func.isRequired,
  /**
   * Synthetic event
   */
  onMouseLeave: _propTypes["default"].func.isRequired,
  onKeyPress: _propTypes["default"].func.isRequired,
  /**
   * Role value
   */
  role: _propTypes["default"].string
};
SwitchBaseInput.defaultProps = {
  name: undefined,
  role: undefined
};
var _default = SwitchBaseInput;
exports["default"] = _default;